// NPM
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import moment from 'moment';

// HELPER
import { toaster, generateCode } from 'Helpers/index';
import { encode } from "Helpers/enc";

// ANT COMPONENT
import Icon, {
  PlusCircleOutlined,
  MinusCircleOutlined, SyncOutlined,
  DownloadOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';
import { Space, Row, Col, Radio, Divider, Timeline } from 'antd';
import { Button, Tabs, BasicModal, SkeletonLoader } from '@life-line-lab/components-react';

// STYLE
import './order-details.scss';

// HOOK
import useSession from 'Hooks/session.hook';

interface OrderDetailsProps {
  getReceipt: ({ }: any) => void;
  orderList: any,
  status: any,
  dispatchedData: any,
}

const OrderDetails: React.FC<OrderDetailsProps> = ({ orderList, status, getReceipt, dispatchedData }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { profile } = useSession();


  const deliveryType = {
    'STANDARD': 'Standard',
    'NEXT_DAY': 'Next Day',
    'EXPRESS': 'Express'
  }

  const courierType = {
    'NINJA_VAN': 'Ninja Van'
  }

  const onProductClick = (inventory) => {
    const inventoryID = encode(inventory._id);
    history.push('/products/' + inventoryID);
  }
  const [receiptPopup, setReceiptPopup] = useState<boolean>(false);
  const onReceipt = (obj) => {
    setReceiptPopup(true);
    getReceipt({
      "orderID": obj._id
    })
  }

  const onCloseModal = () => {
    setReceiptPopup(false)
  }
  const [receiptObj, setReceiptObj] = useState<any>({})
  const downloadReceipt = () => {
    window.open(receiptObj.file_url)
    onCloseModal();
  }

  useEffect(() => {
    if (status.receipt == 'failed') {
      onCloseModal()
    }
    if (status.receipt == 'success') {
      setReceiptObj(status.data)
    }
  }, [status])

  return (
    <div className="product order-list">

      <BasicModal title="Receipt" isClosable={true} isMaskClosable={true} isOpen={receiptPopup} onClose={onCloseModal}>
        <div className="receipt-modal">
          <div>
            {status.receipt == 'loading' ?

              <div className="main-title">
                <SyncOutlined spin />
                <div>{t('txt.generatingReceipt')}</div>
              </div>
              :
              <>
                <div className="main-title"> {t('txt.downloadYourReceiptHere')}</div>
                <Button
                  className="btn-buy"
                  type="primary"
                  label={
                    <React.Fragment>
                      <span>{t('action.downloadReceipt')}</span> <DownloadOutlined />
                    </React.Fragment>
                  }
                  size="large"
                  onClick={() => downloadReceipt()}
                />
              </>}
          </div>


        </div>
      </BasicModal>


      {!orderList?.length ?
        <>
          <SkeletonLoader type="default" />
          <SkeletonLoader type="default" />
          <SkeletonLoader type="default" />
        </>
        :
        <Row gutter={16}>

          {orderList?.length ? orderList.map((o, i) => {
            return (
              <div className="shopping-details my-20">
                <Col lg={24} md={24} sm={24} xs={24}>

                  <div className="cart-table">

                    <div className="ordersection">
                      <Row gutter={16} className="rrow">
                        <Col lg={1} md={1} sm={1} xs={0} className="ccol"></Col>

                        <Col lg={4} md={4} sm={8} xs={12} className="ccol flex-align-center">
                          <div className="title">#{o.orderCode}</div>
                        </Col>
                        <Col lg={4} md={4} sm={8} xs={12} className="ccol">
                          <div className="title">{t('label.trackingNumber')}</div>
                          <div className="val">
                            <strong>{dispatchedData.trackingNumber || "-"}</strong>
                          </div>
                          {/* <div className="title"> <strong>{dispatchedData.trackingNumber || "-"}</strong></div> */}
                        </Col>
                        <Col lg={4} md={4} sm={8} xs={12} className="ccol">
                          <div className="title">{t('label.orderPaymentStatus')}</div>
                          <h4 className="pay-sts color-secondary">
                            <strong>
                              {o.payment_data?.status && o.payment_data?.status != 'NOT_FOUND' ? o.payment_data?.status : t('txt.UNPAID')}
                            </strong>
                            <div>
                              {o.payment_data?.receipt && <a className="view-receipt" onClick={() => { onReceipt(o) }}>{t('action.viewReceipt')}</a>}
                            </div>
                          </h4>
                        </Col>
                        {o.status === 'OPEN' ? <Col lg={4} md={8} sm={8} xs={12} className="ccol">
                          <div className="title">{t('label.deliveryStatus')}</div>
                          <h4 className="val color-secondary"><strong> {t('txt.orderProcessing')} </strong></h4>
                        </Col> : null}
                      </Row>



                      <Row gutter={16} style={{ borderBottom: '1px solid #ddd', borderRadius: '6px' }}>
                        <Col lg={6} md={6} sm={24} xs={24} className="ccol my-10 px-10">
                          <h4 className="color-secondary">{t('label.shippingTo')}</h4>
                          <div className="val">
                            <strong>{o.receiver.fullName}</strong>
                          </div>
                          <div className="val">{o.shippingAddress.street1}, {o.shippingAddress.street2 ? o.shippingAddress.street2 + ',' : null}<br></br>
                            {o.shippingAddress.city} , {o.shippingAddress.state}<br></br>
                            {o.shippingAddress.postcode}, {o.shippingAddress.country == 'MY' ? 'Malaysia' : null}
                          </div>
                        </Col>
                        <Col lg={14} md={14} sm={24} xs={24} className="ccol">

                          <Space className="fulfillment-form--inner my-40" direction="vertical" size="large">
                            {/*<h4 className="color-secondary text-center my-10">{t('title.deliveryUpdates')}</h4>*/}

                            <Timeline mode="left">
                              <Timeline.Item key={i} label={moment(o.createdAt).locale('en').format('DD-MM-YYYY hh:mm a')}>Order Placed</Timeline.Item>

                              {map(o.deliveryUpdates, (update, i) => {
                                return (<Timeline.Item key={i} label={moment(update.timestamp).locale('en').format('DD-MM-YYYY hh:mm a')}>{update.status}</Timeline.Item>)
                              })}
                            </Timeline>
                          </Space>
                        </Col>

                        <Col lg={4} md={4} sm={24} xs={24} className="ccol my-10 px-10">
                          {o.payment_data?.status == 'PAID' ? <>
                            <h4 className="val color-secondary"><strong>{deliveryType[o.deliveryInfo?.deliveryType]} {t('txt.Delivery')}</strong></h4>

                            {o.status === 'OPEN' || o.status === 'DISPATCH_INPROGRESS' ?
                              <div className="font-12">
                                {o?.orderDate && <strong> {t('label.receiveBy')} {moment(o?.orderDate).add(4, 'days').format('DD MMM')} - {moment(o?.orderDate).add(11, 'days').format('DD MMM')}</strong>} <br />
                                {dispatchedData?.courier ? <strong>via {courierType[dispatchedData.courier]}</strong> : null}
                              </div>
                              : null
                            }
                          </> : <h4>-</h4>}
                        </Col>
                      </Row>

                      <Row gutter={16} style={{ borderBottom: '1px solid #ddd', borderRadius: '6px' }}>
                        <Col lg={24} md={24} sm={24} xs={24} className="ccol">
                          {o.items.map((record, j) => {
                            let itemImage = record.product.product.images?.[0]?.file_data?.file_url || '/assets/images/product-placeholder.png';
                            const variantCode = record.variantCode;
                            if (variantCode && record.product.product?.images?.length) {
                              const matchedImageLink = record.product.product?.images.find(elem => elem.variantCode === variantCode);
                              if (matchedImageLink) {
                                itemImage = matchedImageLink.file_data?.file_url || itemImage;
                              }
                            }

                            return (
                              <Row gutter={16} className={"image-section " + (o.status == 'OPEN' ? '' : '')}>
                                <Col lg={1} md={1} sm={1} xs={0} className="ccol"></Col>
                                <Col lg={3} md={3} sm={3} xs={6} className="ccol">
                                  <img
                                    alt={t('alt.logo')}
                                    src={itemImage}
                                    style={{ width: '100%', height: '100%' }}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src = '/assets/images/product-placeholder.png';
                                    }}
                                  /> &nbsp;
                                </Col>
                                <Col lg={16} md={16} sm={16} xs={16} className="ccol info my-0">
                                  <div onClick={() => onProductClick(record.product)} style={{ textTransform: 'capitalize', fontSize: '16px' }}> <strong>{record.product.product.name}</strong></div>
                                  <h5 className="color-secondary"><strong>({record.variant}) x {record.quantity}</strong></h5>
                                  <h4 className="color-secondary"><strong>RM {parseFloat(record.unitPrice).toFixed(2)}</strong></h4>
                                </Col>

                                {/*<Col lg={4} md={4} sm={24} xs={24} className="ccol info">
                                  <h4 className="color-secondary text-center"><strong>RM {parseFloat(record.amount).toFixed(2)}</strong></h4>
                                </Col>*/}
                              </Row>
                            )
                          })}
                        </Col>
                      </Row>



                      <Row gutter={16} className="order-total">
                        <Col lg={12} md={12} sm={12} xs={24}>
                          <div className="py-10 color-primary"> {t('txt.soldby')} : {o.supplier.name} </div></Col>
                        <Col lg={12} md={12} sm={12} xs={24} className="line-gap">
                          <div className="order-price-details">
                            <div><span>{t('label.productSubtotal')}:</span></div>
                            <div><span>&nbsp;RM{parseFloat(o.paymentDetails.subTotal).toFixed(2)}</span></div>

                            <div><span>{t('label.shippingTotal')}:</span></div>
                            <div><span>&nbsp;RM{parseFloat(o.paymentDetails.shippingFee).toFixed(2)}</span></div>

                            <div><span>{t('label.voucherDiscount')}:</span></div>
                            <div><span>-RM{(parseFloat(o.paymentDetails.orderDiscount)+parseFloat(o.paymentDetails.shippingDiscount)).toFixed(2)}</span></div>

                            <div><h3 className="color-secondary">{t('txt.orderTotal')}:</h3></div>
                            <div><h3 className="color-secondary">&nbsp;RM{parseFloat(o.paymentDetails.total).toFixed(2)}</h3></div>

                            <div><span>{t('title.paymentMethod')}:</span></div>
                            <div><span>{o.payment_data.type}</span></div>
                          </div>
                        </Col>

                      </Row>

                    </div>
                  </div>

                </Col>
              </div>
            )
          }) :

            <div className="my-10 m-auto justify-center">
              <div>
                <img
                  alt={t('alt.logo')}
                  src='/assets/images/empty-box.png'
                  width={200}
                />
                <h3 className="color-primary"><strong>{t('txt.trackingDetailsNotFound')}</strong></h3>
              </div>
            </div>}
        </Row>
      }
    </div>
  )
}


export default OrderDetails;
